(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ml-floating-video-bubble"]) return;
  try {
    
  (function(){
    function clamp(value, min, max){
      return Math.min(Math.max(value, min), max);
    }

    function schedule(callback){
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 1600 });
        return;
      }
      window.setTimeout(callback, 450);
    }

    function setPosition(root, left, top){
      var size = root.getBoundingClientRect();
      var maxLeft = Math.max(0, window.innerWidth - size.width);
      var maxTop = Math.max(0, window.innerHeight - size.height);
      root.style.left = clamp(left, 0, maxLeft) + 'px';
      root.style.top = clamp(top, 0, maxTop) + 'px';
      root.style.right = 'auto';
      root.style.bottom = 'auto';
    }

    function savePosition(root){
      var key = root.getAttribute('data-ml-floating-storage-key');
      if (!key) return;
      var rect = root.getBoundingClientRect();
      try {
        window.localStorage.setItem(key, JSON.stringify({ left: rect.left, top: rect.top }));
      } catch (error) {}
    }

    function restorePosition(root){
      var key = root.getAttribute('data-ml-floating-storage-key');
      if (!key) return;
      try {
        var saved = JSON.parse(window.localStorage.getItem(key));
        if (!saved) return;
        if (typeof saved.left !== 'number') return;
        if (typeof saved.top !== 'number') return;
        setPosition(root, saved.left, saved.top);
      } catch (error) {}
    }

    function loadVideoElement(video){
      if (!video) return;
      if (video.hasAttribute('data-ml-floating-loaded')) return;

      var src = video.getAttribute('data-ml-floating-video-src');
      if (!src) return;

      var source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.setAttribute('data-ml-floating-loaded', 'true');
      video.muted = true;
      video.load();
    }

    function playVideo(video){
      if (!video) return;
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function(){});
    }

    function loadVideo(root){
      var video = root.querySelector('[data-ml-floating-video-media]');
      loadVideoElement(video);

      var play = function(){
        playVideo(video);
      };

      if (video.readyState >= 2) {
        play();
      } else {
        video.addEventListener('canplay', play, { once: true });
      }
    }

    function getModal(){
      return document.querySelector('[data-ml-floating-video-modal]');
    }

    function openModal(){
      var modal = getModal();
      if (!modal) return;
      var sheet = modal.querySelector('[data-ml-floating-modal-sheet]');
      var video = modal.querySelector('[data-ml-floating-modal-media]');
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.remove('is-dragging');
      if (sheet) sheet.style.setProperty('--ml-floating-modal-y', '0px');
      document.documentElement.classList.add('ml-floating-video-modal-open');
      loadVideoElement(video);
      if (video) {
        video.muted = false;
        video.currentTime = 0;
        playVideo(video);
      }
    }

    function closeModal(){
      var modal = getModal();
      if (!modal) return;
      var sheet = modal.querySelector('[data-ml-floating-modal-sheet]');
      var video = modal.querySelector('[data-ml-floating-modal-media]');
      if (video) video.pause();
      if (sheet) sheet.style.setProperty('--ml-floating-modal-y', '0px');
      modal.classList.remove('is-dragging');
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ml-floating-video-modal-open');
    }

    function bindModal(){
      var modal = getModal();
      if (!modal || modal.hasAttribute('data-ml-floating-modal-bound')) return;
      modal.setAttribute('data-ml-floating-modal-bound', 'true');

      modal.querySelectorAll('[data-ml-floating-modal-close]').forEach(function(button){
        button.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function(event){
        if (event.key == 'Escape' && !modal.hidden) closeModal();
      });

      var sheet = modal.querySelector('[data-ml-floating-modal-sheet]');
      if (!sheet) return;
      var pointerId = null;
      var startY = 0;
      var currentY = 0;

      sheet.addEventListener('pointerdown', function(event){
        if (event.target.closest && event.target.closest('button, video')) return;
        pointerId = event.pointerId;
        startY = event.clientY;
        currentY = 0;
        modal.classList.add('is-dragging');
        sheet.setPointerCapture(pointerId);
      });

      sheet.addEventListener('pointermove', function(event){
        if (event.pointerId !== pointerId) return;
        currentY = Math.max(0, event.clientY - startY);
        sheet.style.setProperty('--ml-floating-modal-y', currentY + 'px');
      });

      function endSheetDrag(event){
        if (event.pointerId !== pointerId) return;
        try { sheet.releasePointerCapture(pointerId); } catch (error) {}
        modal.classList.remove('is-dragging');
        pointerId = null;
        if (currentY > 110) {
          closeModal();
          return;
        }
        currentY = 0;
        sheet.style.setProperty('--ml-floating-modal-y', '0px');
      }

      sheet.addEventListener('pointerup', endSheetDrag);
      sheet.addEventListener('pointercancel', endSheetDrag);
    }

    function lazyLoad(root){
      schedule(function(){
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              if (!entry.isIntersecting) return;
              loadVideo(root);
              observer.disconnect();
            });
          }, { rootMargin: '220px' });
          observer.observe(root);
          window.setTimeout(function(){ loadVideo(root); }, 4200);
          return;
        }
        loadVideo(root);
      });
    }

    function bindDrag(root){
      var handle = root.querySelector('[data-ml-floating-drag-handle]');
      if (!handle) return;

      var pointerId = null;
      var startX = 0;
      var startY = 0;
      var startLeft = 0;
      var startTop = 0;
      var moved = false;

      handle.addEventListener('pointerdown', function(event){
        if (event.button !== undefined && event.button !== 0) return;
        var rect = root.getBoundingClientRect();
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        startLeft = rect.left;
        startTop = rect.top;
        moved = false;
        root.classList.add('is-dragging');
        handle.setPointerCapture(pointerId);
      });

      handle.addEventListener('pointermove', function(event){
        if (pointerId !== event.pointerId) return;
        event.preventDefault();
        if (Math.abs(event.clientX - startX) > 6 || Math.abs(event.clientY - startY) > 6) moved = true;
        setPosition(root, startLeft + event.clientX - startX, startTop + event.clientY - startY);
      });

      function endDrag(event){
        if (pointerId !== event.pointerId) return;
        root.classList.remove('is-dragging');
        try { handle.releasePointerCapture(pointerId); } catch (error) {}
        if (moved) {
          root.setAttribute('data-ml-floating-was-dragged', 'true');
          window.setTimeout(function(){ root.removeAttribute('data-ml-floating-was-dragged'); }, 80);
        }
        pointerId = null;
        savePosition(root);
      }

      handle.addEventListener('pointerup', endDrag);
      handle.addEventListener('pointercancel', endDrag);

      handle.addEventListener('keydown', function(event){
        var step = event.shiftKey ? 24 : 12;
        var rect = root.getBoundingClientRect();
        var left = rect.left;
        var top = rect.top;

        if (event.key == 'ArrowLeft') left -= step;
        else if (event.key == 'ArrowRight') left += step;
        else if (event.key == 'ArrowUp') top -= step;
        else if (event.key == 'ArrowDown') top += step;
        else return;

        event.preventDefault();
        setPosition(root, left, top);
        savePosition(root);
      });

      handle.addEventListener('click', function(event){
        if (root.hasAttribute('data-ml-floating-was-dragged')) return;
        event.preventDefault();
        openModal();
      });
    }

    function init(root){
      if (!root || root.hasAttribute('data-ml-floating-bound')) return;
      root.setAttribute('data-ml-floating-bound', 'true');
      restorePosition(root);
      lazyLoad(root);
      bindDrag(root);
      bindModal();

      window.addEventListener('resize', function(){
        var rect = root.getBoundingClientRect();
        setPosition(root, rect.left, rect.top);
      });
    }

    function initAll(scope){
      var base = scope || document;
      base.querySelectorAll('[data-ml-floating-video-bubble]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function(event){
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
